import React, {useEffect, useRef, useState, Fragment} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import FeatureInfo from "../../selectionWindow/selectionFeatureInfo/featureInfo";
// import MaterialsWizardMainList from "./materialsWizardMainList";
import MaterialsMainCanvas from "../materialsCommon/materialsMainCanvas";
import {
  displayMaterialsWizardGroupAsFeature,
  // getAvailableSteps,
  getCurrentGroups,
  getCurrentWizardNavItems,
  getFeatureGroupFromWizardGroup, getMissingWizardFeatures, getWizardMissingKey, shouldUseNewWizardFeaturesRequestsLogic
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setSelectionWindowView} from "../../../actions/actionFunctions";
import {getCurrentLayout} from "../../appLayout";
import MaterialsWizardMainList from "./materialsWizardMainList";
import PropTypes from "prop-types";
import SelectionMainHeader from "../../selectionWindow/selectionMainHeader";
import {ROUTES} from "../../../routes";
import FiltersClass from "../../visComponents/navigation/newFilters/filters";
import {searchProductRequest} from "../../../api/search-api";
import {setGroheFiltersSearchText} from "../../../actions/groheFunctions";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {setNavigationLoading} from "../../../actions/navigationFunctions";
import {setMaterialsCanvasClass} from "../../../actions/selectionFunctions";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import Config, {IS_OFFLINE_MODE} from "../../../config";
import {setWizardSelectedValues} from "../../../actions/wizardFunctions";
import store from "../../../store";
import Gallery from "../../selectionWindow/gallery";
import useDebounce, {useIsMounted, useUpdateMatchAllButton} from "../../../misc/helperHooks";
import {getNavigationButtons} from "../../../api/server-api";

let timeoutForSetNavItems = null;

const MaterialsWizardMain = (props) => {

  const {currentGroups, selectionFeatureInfo, history, wizardSelectedValues, wizardActiveStep, wizardActiveItem,
    filterGroups, isMobile, selectionWindowView, setSelectionWindowView, groheFiltersSearchText, selectedFilters,
    setGroheFiltersSearchText, navigationCount, setNavigationLoading, setMaterialsCanvasClass, visualizerIsChanging,
    wizardMissingFeatures, cartItems, setWizardSelectedValues, activeQuoteIndex, galleryVisible, bvOpened,
    networkConnection} = props;

  const [navItems, setNavItems] = useState([]);
  const scrollElem = useRef();
  const isMounted = useIsMounted();

  // const [additionalFeaturesLoading, setAdditionalFeaturesLoading] = useState(false);

  const wizardGroup = currentGroups[0];

  const layout = getCurrentLayout();
  const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);

  const setNavigationItems = async () => {

    if (visualizerIsChanging) {
      return false
    }

    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    const wizardGroup = currentGroups[0];
    const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);

    if (Config.isDevMode()) {
      console.log("currentGroups", currentGroups);
      console.log("featureGroup", featureGroup);
    }

    if (displayMaterialsWizardGroupAsFeature(currentGroups)) {
      // console.log("currentGroups", currentGroups);
      setNavItems([...currentGroups]) // keep wizardGroups as is
      setNavigationLoading(false);
      return
    }

    // if (currentGroups[0].nodeType === "filter") {
    //   return <LookWizardSectionFilters wizardGroup={currentGroups[0]}/>
    // }

    if (Config.isDevMode()) {
      console.log("wizardGroup", wizardGroup);
    }

    if (featureGroup && !featureGroup.allFeaturesReceived) {
      const step = wizardActiveStep;
      await checkIfLookFeaturesReceived(featureGroup, false);
      const currentStep = store.getState().wizardState.wizardActiveStep;
      if (step !== currentStep) {
        return false
      }
    }

    let newNavItems = featureGroup ? getCurrentWizardNavItems(
      wizardSelectedValues,
      wizardActiveStep,
      wizardActiveItem,
      wizardGroup,
      featureGroup,
      filterGroups,
      groheFiltersSearchText,
      selectedFilters
    ) : [];

    // only request first time!! then only on scroll
    const key = getWizardMissingKey(wizardActiveItem, wizardGroup);
    if (featureGroup && shouldUseNewWizardFeaturesRequestsLogic(wizardGroup, featureGroup)
      && !wizardMissingFeatures[key]) {
      const shouldUpdateNavItems = await getMissingWizardFeatures(newNavItems, wizardGroup, featureGroup);
      if (shouldUpdateNavItems) {
        newNavItems = getCurrentWizardNavItems(
          wizardSelectedValues,
          wizardActiveStep,
          wizardActiveItem,
          wizardGroup,
          featureGroup,
          filterGroups,
          groheFiltersSearchText,
          selectedFilters
        );
      }
    }

    if (!isMounted()) {
      return
    }

    setNavItems(newNavItems);
    setNewCanvasClass(newNavItems);
    setNavigationLoading(true);
    timeoutForSetNavItems = setTimeout(() => {
      setNavigationLoading(false);
    }, 0)
  }

  const updateViewType = () => {
    if (wizardGroup) {
      if (isMobile && (!wizardGroup.viewType || wizardGroup.viewType === 3)) {
        if (selectionWindowView !== 2) {
          setSelectionWindowView(2); // mobile set
        }
      } else if (wizardGroup.viewType && (wizardGroup.viewType !== selectionWindowView)) {
        setSelectionWindowView(wizardGroup.viewType); // from part
      } else if (!wizardGroup.viewType && (selectionWindowView !== 3)) {
        setSelectionWindowView(3); // default
      }
    } else if (isMobile && selectionWindowView === 3) {
      setSelectionWindowView(2);
    }
  }

  const setNewCanvasClass = (newNavItems) => {
    if (!featureGroup || !newNavItems.length) {
      return
    }
    if (newNavItems.every(navItem => navItem.part.notAvailableInVisualizer) && wizardActiveStep > 0) {
      const layout = getCurrentLayout();
      for (let i = wizardActiveStep - 1; i > - 1; i--) {
        const currentGroups = getCurrentGroups(wizardActiveItem, i, wizardSelectedValues);
        const wizardGroup = currentGroups[0];
        const prevFeatureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
        if (prevFeatureGroup) { // just in case
          const navItemsForPrevParent = layout.designNavigationItems({part: prevFeatureGroup},[], "",true, false);
          if (navItemsForPrevParent.length && navItemsForPrevParent.some(navItem => !navItem.part.notAvailableInVisualizer)) {
            setMaterialsCanvasClass(prevFeatureGroup.partId);
            return; // stop searching
          }
        }
      }
    }
    setMaterialsCanvasClass(featureGroup.partId)
  }

  useEffect(() => {
    setNavigationItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep, wizardActiveItem, selectedFilters, groheFiltersSearchText, navigationCount,
    visualizerIsChanging, bvOpened]) // bvOpened is needed because we could change the room

  useEffect(() => {
    if (featureGroup && !wizardSelectedValues[wizardActiveStep]) {
      // set wizard step value if cart item was added (from sqft for example)
      const alreadyAddedCartItem = cartItems.find(cartItem => {
        return cartItem.partId === featureGroup.partId && cartItem.currentQuote === activeQuoteIndex
      });
      if (alreadyAddedCartItem) {
        setWizardSelectedValues({
          [wizardActiveStep]: {
            wizardGroup,
            selectedFeature: alreadyAddedCartItem.cartFeature,
            partId: featureGroup.partId,
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup]);

  useEffect(() => {
    updateViewType();
    if (IS_OFFLINE_MODE && networkConnection) {
      getNavigationButtons(true, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep, wizardActiveItem]);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutForSetNavItems);
      if (groheFiltersSearchText) {
        setGroheFiltersSearchText("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setShowLoader = (showLoader) => {
    if (showLoader) {
      setNavigationLoading(true); // it's not working yet, as we have this.state.additionalFeaturesLoading
      clearTimeout(timeoutForSetNavItems); // prevent turing it off
    } else {
      setNavigationItems();
    }
  }

  useDebounce(async () => {
    if (featureGroup && !featureGroup.getRealFeaturesReceivedProperty()) {
      return searchProductRequest(featureGroup, groheFiltersSearchText, setShowLoader)
    }
  }, [groheFiltersSearchText], 800);

  useUpdateMatchAllButton(wizardGroup, featureGroup);

  const handleInputChange = async (event) => {
    setGroheFiltersSearchText(event.target.value);
  }

  return (
    <Fragment>
      <div className="selection-body">
        <div className="selection-main">
          <MaterialsMainCanvas canvasCollapsing={false}
                               canvasExpanding={false}
                               canvasImageStyles={null}
                               features={navItems}
                               listItemHeight={300}
                               goToBV={() => {
                                 history.push(ROUTES.visualizer)
                               }}
                               wizardGroup={wizardGroup}
                               activeSubPart={featureGroup ? {part: featureGroup} : null}
                               handleUserLoginClick={() => {}}/>
          {selectionFeatureInfo && featureGroup ? (
            <FeatureInfo
              features={navItems}
              handleFeatureClick={() => {}}
              activePart={featureGroup.getParent()}
              changeActivePartRelatedItem={() => {}}
            />
          ) : (
            <div id="selection-main__bv-item" className="selection-main__bv-item">
              <SelectionMainHeader handleSearchInputChange={handleInputChange}
                                   searchText={groheFiltersSearchText}
                                   activeSubPart={featureGroup ? {part: featureGroup} : null}/>
              {!currentGroups.length ? null : <MaterialsWizardMainList
                setRef={(node) => scrollElem.current = node}
                currentGroups={currentGroups}
                currentParent={featureGroup}
                features={navItems}
                wizardGroup={wizardGroup}
                // showItemsList={!this.props.searchRequest && this.state.showItemsList}
                handleUserLoginClick={() => {}}
                layoutName={layout.getCurrentLayoutName()}
                checkIfNeedToSwitchRoom={false}
              />}
            </div>
          )}
        </div>
      </div>
      {featureGroup ? <FiltersClass id="selectionWindow"
                                    searchText={groheFiltersSearchText}
                                    handleSearchInputChange={handleInputChange}
                                    layout={layout}
                                    childItem={{part: featureGroup}} /> : null}
      {selectionFeatureInfo && featureGroup && galleryVisible ? <Gallery/> : null}
    </Fragment>
  )

};

MaterialsWizardMain.propTypes = {
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface))
}

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem, wizardSelectedValues, wizardActiveStep, wizardMissingFeatures} = store.wizardState;
  const {selectionFeatureInfo, selectionWindowView, galleryVisible} = store.selectionState;
  const {filterGroups, selectedFilters} = store.filterState;
  const {networkConnection, isMobile, visualizerIsChanging} = store.serverState;
  const {groheFiltersSearchText} = store.groheState;
  const {navigationCount} = store.lookState;
  const {cartItems} = store.cartState;
  const {activeQuoteIndex} = store.quotesState;
  const {bvOpened} = store.bathroomVisualizerState;

  return {
    wizardList,
    wizardActiveItem,
    wizardSelectedValues,
    wizardActiveStep,
    selectionFeatureInfo,
    selectionWindowView,
    galleryVisible,
    filterGroups,
    isMobile,
    selectedFilters,
    groheFiltersSearchText,
    navigationCount,
    wizardMissingFeatures,
    cartItems,
    activeQuoteIndex,
    visualizerIsChanging,
    bvOpened,
    networkConnection,
  };
};

const mapDispatchToProps = {
  setSelectionWindowView,
  setGroheFiltersSearchText,
  setNavigationLoading,
  setMaterialsCanvasClass,
  setWizardSelectedValues,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardMain)
)
